module.exports = __webpack_public_path__ + "img/step-checked.172029a4.svg";